export const TableFooterComponent = {
  templateUrl: './app/ajs/_shared/components/table-footer/table-footer.component.html',
  bindings: {
    meta: '<',
    filterCriteria: '<',
    selectPage: '&',
  },
  controller: function () {},
  controllerAs: 'vm',
};

// import { NgModule } from '@angular/core/'

// @NgModule({
//     selector:   'app-table-footer',
//     templateUrl: './table-footer.component.html'
// })
// export class TableComponent {
//     @input()
// }
